'use client';
import { selfPercentileColor, ordinal, type AxisStat, type SelfPercentiles } from './percentile-helpers';
import { useResource } from '@/lib/use-resource';

export function SelfPercentileRow({ symbol }: { symbol: string }) {
  const { data } = useResource<SelfPercentiles>(`/api/self-percentiles?symbol=${encodeURIComponent(symbol)}`);
  if (!data) return null;

  const renderCell = (heading: string, ax: AxisStat | undefined) => {
    if (!ax || ax.percentile == null) return <div className="flex-1" />;
    const color = selfPercentileColor(ax.percentile);
    return (
      <div className="flex-1 flex justify-center">
        <div
          className="text-[10px] px-2 py-1 rounded-md tabular-nums font-mono leading-tight text-center"
          style={{ color, backgroundColor: `${color}15`, border: `1px solid ${color}40` }}
          title={`This stock's ${heading.toLowerCase()} TODAY ranks at the ${ordinal(Math.round(ax.percentile))} percentile of its own ${ax.count}-observation history (${ax.firstObs} → ${ax.lastObs}). Higher percentile = better (or cheaper). Mean ${ax.mean.toFixed(2)}, stdev ${ax.stdev.toFixed(2)}.`}
        >
          <div className="text-[8px] uppercase tracking-wider opacity-70">{heading} vs history</div>
          <div className="text-[12px] font-bold">{ordinal(Math.round(ax.percentile))} percentile</div>
          <div className="text-[8px] opacity-80">{ax.regime}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="grid grid-cols-3 gap-6 mt-2">
      {renderCell('Quality', data.q)}
      {renderCell('Valuation', data.v)}
      {renderCell('Composite', data.composite)}
    </div>
  );
}
